export const orderStatuses = {
  ordered: 'ordered',
  delivered: 'delivered',
  declined: 'declined',
};
